import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';

const SendEmailResto = async (data) => {
  return await axios.post(`${BASE_URL}/api/restaurant/envoyeEmailResto`, data, {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
    }
  });
}



export { SendEmailResto }